/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-event-list-item[_ngcontent-%COMP%]{border:1px solid #ccc;padding-left:8px;padding-bottom:8px;margin-top:4px}"];
export { styles as styles };
